module.exports = __webpack_public_path__ + "img/retro_main.56ca3c74.gif";